import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { FaFire, FaStar, FaChartLine, FaDollarSign, FaHome } from 'react-icons/fa';
import { IoSparkles } from 'react-icons/io5';
import dealService, { DealSummary } from '../../services/dealService';

interface DealSummaryCardsProps {
  summary: DealSummary;
  totalDeals: number;
}

const DealSummaryCards: React.FC<DealSummaryCardsProps> = ({ summary, totalDeals }) => {
  const cards = [
    {
      title: 'A+ DEALS',
      value: summary.grade_a_plus || 0,
      icon: <FaFire />,
      color: '#dc3545',
      emoji: '🔥'
    },
    {
      title: 'A DEALS',
      value: summary.grade_a || 0,
      icon: <FaStar />,
      color: '#fd7e14',
      emoji: '⭐'
    },
    {
      title: 'B DEALS',
      value: summary.grade_b || 0,
      icon: <IoSparkles />,
      color: '#ffc107',
      emoji: '✨'
    },
    {
      title: 'TOTAL DEALS',
      value: totalDeals,
      icon: <FaHome />,
      color: '#6c757d',
      emoji: '📊'
    },
    {
      title: 'AVG ROI',
      value: `${summary.avg_roi || 0}%`,
      icon: <FaChartLine />,
      color: '#28a745',
      emoji: '📈'
    },
    {
      title: 'PROFIT POTENTIAL',
      value: dealService.formatCurrency(summary.total_profit_potential || 0),
      icon: <FaDollarSign />,
      color: '#007bff',
      emoji: '💵'
    }
  ];

  return (
    <Row className="mb-4 g-3">
      {cards.map((card, index) => (
        <Col key={index} xs={6} md={4} lg={2}>
          <Card className="h-100 text-center" style={{ borderTop: `3px solid ${card.color}` }}>
            <Card.Body>
              <div className="d-flex justify-content-center align-items-center mb-2">
                <span style={{ fontSize: '2em', marginRight: '8px' }}>{card.emoji}</span>
                <div style={{ color: card.color, fontSize: '1.5em' }}>
                  {card.icon}
                </div>
              </div>
              <h6 className="text-muted small mb-1">{card.title}</h6>
              <h3 className="mb-0" style={{ color: card.color }}>
                {card.value}
              </h3>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default DealSummaryCards;